/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AdministrationUsersInformation } from '../../models/administration-users-information';
import { KeyType } from '../../models/key-type';

export interface GetAdministrationOrganizationSiteUsers$Params {

/**
 * The organization site key
 */
  organizationSiteKey: KeyType;
}

export function getAdministrationOrganizationSiteUsers(http: HttpClient, rootUrl: string, params: GetAdministrationOrganizationSiteUsers$Params, context?: HttpContext): Observable<StrictHttpResponse<AdministrationUsersInformation>> {
  const rb = new RequestBuilder(rootUrl, getAdministrationOrganizationSiteUsers.PATH, 'get');
  if (params) {
    rb.path('organizationSiteKey', params.organizationSiteKey, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AdministrationUsersInformation>;
    })
  );
}

getAdministrationOrganizationSiteUsers.PATH = '/administration/organization-sites/{organizationSiteKey}/users';
